import { ButtonGroup } from '@mui/material';
import { getPriorityFilters, PRIORITY_COLORS, PriorityIcon } from 'utils/helper';
import MDBox from './MDBox';
import MDButton from './MDButton';
import MDTypography from './MDTypography';

const priorities = getPriorityFilters(false);
const selectedColor = '#FCF1FE';

const PriorityGroupButton = ({ name = 'priority', value, handleChange, disabled }) => {
    return (
        <>
            <MDTypography variant="caption">Priority</MDTypography>
            <MDBox>
                <ButtonGroup variant="outlined">
                    {priorities.map((priority) => (
                        <MDButton
                            key={priority.value}
                            onClick={() => disabled ? {} : handleChange({ target: { name: name, value: priority.value } })}
                            variant="outlined"
                            color="secondary"
                            sx={{
                                ...(value === priority.value
                                    ? { backgroundColor: selectedColor + " !important", color: 'white !important' }
                                    : { color: PRIORITY_COLORS[priority.value] }),
                                '&:focus': {
                                    outline: 'none !important',
                                    boxShadow: 'none !important'
                                },
                                '&:focus-visible': {
                                    outline: 'none !important',
                                    boxShadow: 'none !important'
                                },
                                '&:focus:not(:hover)': {
                                    outline: 'none !important',
                                    boxShadow: 'none !important'
                                },
                                '&:active': {
                                    backgroundColor: value === priority.value ? selectedColor + " !important" : 'initial'
                                },
                                '&:hover': {
                                    backgroundColor: value === priority.value ? selectedColor + " !important" : 'initial',
                                    borderColor: "#D2D6DA"
                                },
                                borderColor: "#D2D6DA"
                                ,
                                cursor: disabled ? 'default' : 'pointer'
                            }}
                            startIcon={PriorityIcon(priority.value)}
                        >
                            <span style={{ color: '#333' }}>{priority.label}</span>
                        </MDButton>
                    ))}
                </ButtonGroup>
            </MDBox>
        </>
    );
};

export default PriorityGroupButton;